
/**
 * @file
 * Provides base widget behaviours.
 */

(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.imcs_navbar = {
    attach: function (context) {

      once('mobile-navbar', '#header-navbar', context).forEach((navbar) => {
        // hidden.bs.collapse - fired when fully hidden.
        navbar.addEventListener('hide.bs.collapse', function () {
          jQuery('main').fadeIn();
          jQuery('footer').fadeIn();
        });
        // shown.bs.collapse - fired when fully shown.
        navbar.addEventListener('show.bs.collapse', function () {
          jQuery('main').fadeOut();
          jQuery('footer').fadeOut();
        });

        $('.nav-item').each(function() {
          // Check if this nav-item has the 'active' class
          if ($(this).hasClass('active')) {
            // Find the dropdown-menu immediately following this nav-item
            // and add the 'show' class.
            $(this).find('.dropdown-menu').addClass('show');
          }
        });
      });
    }
  };

})(jQuery, Drupal, once);
